import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const arrowRightFilled: ISVGPersonalProps = {
  viewBox: '0 0 15.709 12.766',
  content: (
    <>
      <defs>
        <clipPath id="clipPath">
          <rect id="Rectangle_2658" data-name="Rectangle 2658" width="12.766" height="15.709" fill="#1c7903" />
        </clipPath>
      </defs>
      <g id="right_arrow" data-name="right arrow" transform="translate(0 12.766) rotate(-90)">
        <g id="Group_2217" data-name="Group 2217" clipPath="url(#clipPath)">
          <path
            id="Path_1000"
            data-name="Path 1000"
            d="M12.629,8.987a.484.484,0,0,0-.349-.146H9.724a.361.361,0,0,1-.361-.361v-8A.484.484,0,0,0,8.879,0H3.9a.484.484,0,0,0-.484.484v8a.361.361,0,0,1-.361.361H.493a.484.484,0,0,0-.347.831L6.04,15.565a.48.48,0,0,0,.686,0L12.62,9.671a.484.484,0,0,0,.009-.684"
            transform="translate(0)"
            fill="#1c7903"
          />
        </g>
      </g>
    </>
  ),
};
